import { useState, useRef, memo } from "react";
import { useTick } from "@pixi/react";
import { Graphics } from "pixi.js";
import { FPSMeterProps } from "./FPSMeter.types";

export const FPSMeter = memo(function FPSMeter({
  x = 10,
  y = 10,
  fontSize = 16,
  fontColor = 0xffffff,
  backgroundColor = 0x000000,
  backgroundAlpha = 0.7,
  padding = 8,
  cornerRadius = 5,
}: FPSMeterProps) {
  const [fps, setFps] = useState(0);
  const frameCountRef = useRef(0);
  const lastTimeRef = useRef(performance.now());

  useTick(() => {
    frameCountRef.current++;
    const now = performance.now();
    const elapsed = now - lastTimeRef.current;

    if (elapsed >= 1000) {
      // Update FPS every second
      const currentFps = Math.round((frameCountRef.current / elapsed) * 1000);

      if (currentFps !== fps) {
        setFps(currentFps);
      }
      frameCountRef.current = 0;
      lastTimeRef.current = now;
    }
  });

  const text = `FPS: ${fps}`;
  const textWidth = fontSize * text.length * 0.6; // Rough estimate
  const textHeight = fontSize * 1.2;

  return (
    <pixiContainer x={x} y={y}>
      {/* Background */}
      <pixiGraphics
        draw={(g: Graphics) => {
          g.clear();
          g.beginFill(backgroundColor, backgroundAlpha);
          g.drawRoundedRect(
            -padding,
            -padding,
            textWidth + padding * 2,
            textHeight + padding * 2,
            cornerRadius
          );
          g.endFill();
        }}
      />

      {/* FPS Text */}
      <pixiText
        text={text}
        style={{
          fontSize,
          fill: fontColor,
          fontFamily: "Arial",
          fontWeight: "bold",
        }}
        x={0}
        y={0}
      />
    </pixiContainer>
  );
});
